var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#00AB58"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1005 23.044H18.7638C18.797 23.4512 18.9343 23.8016 19.1758 24.0952C19.4173 24.384 19.7345 24.6065 20.1275 24.7628C20.5205 24.9143 20.9585 24.9901 21.4414 24.9901C21.9528 24.9901 22.4097 24.9025 22.8121 24.7273C23.2146 24.5473 23.5295 24.2917 23.7567 23.9602C23.9888 23.6241 24.1048 23.2169 24.1048 22.7386C24.1048 22.2983 23.9935 21.8982 23.771 21.5384C23.5531 21.1738 23.2193 20.8849 22.7695 20.6719C22.3197 20.4541 21.7444 20.3452 21.0437 20.3452H19.6019V18.4489L22.9684 14.7557V14.6562H16.8178V12.4545H26.2923V14.358L22.386 18.5625V18.6761C23.1057 18.733 23.7402 18.8845 24.2894 19.1307C24.8434 19.3769 25.3074 19.6918 25.6815 20.0753C26.0555 20.4588 26.3372 20.8897 26.5266 21.3679C26.716 21.8461 26.8107 22.348 26.8107 22.8736C26.8107 23.7259 26.5763 24.4763 26.1076 25.125C25.6436 25.7737 25.0044 26.2827 24.19 26.652C23.3803 27.0166 22.457 27.1989 21.4201 27.1989C20.4258 27.1989 19.5333 27.0284 18.7425 26.6875C17.9566 26.3466 17.3292 25.866 16.8604 25.2457C16.3917 24.6207 16.1384 23.8868 16.1005 23.044Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle3);
export default __webpack_public_path__ + "static/media/Circle-3.a672782b1138f159a0ee0ae76ed5417c.svg";
export { ForwardRef as ReactComponent };